

export function formatMinutesIntoHours(minutes: number): string {
  if (minutes < 0) {
    return "0 hours 0 minutes";
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return `${hours} hours ${remainingMinutes} minutes`;
}